import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import {
    FacebookFilled,
    ViberFilled,
    YoutubeFilled,
    TelegramFilled,
} from "@assets";
import { useTranslation } from 'react-i18next';
import { Space } from 'antd';

const Container = styled.div`
position: absolute;
bottom: 0;

display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

width: 100%;
background-color: #49028E;
`;

const Socials = styled.div`
width: 100%;
padding: 6px 0;
display: flex;
gap: 12px;
align-items: center;
justify-content: center;
background-color: #F0DCFF;
`;

const Contacts = styled.div`
padding: 8px 0 20px 0;
display: flex;
gap: 8px;
flex-direction: column;
align-items: center;
justify-content: center;

.ant-space {
    gap: 12px !important;
}

a {
    text-decoration: none !important;
}
`;

const BoldText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #fff;
`;

const ContactText = styled.div`
display: inline;
height: 16px;
padding: 0 12px;
border-radius: 21px;
background-color: rgba(0, 0, 0, 0.20);
font-size: 10px;
font-weight: 500;
color: #fff;
`;

const SocialText = styled.div`
font-size: 10px;
font-style: normal;
font-weight: 500;
line-height: 1.5;
color: #49028E;
`;

const SocialBox = styled.div`
display: flex;
align-items: center;
gap: 8px;

a {
    display: flex;
}

svg {
    max-width: 29px;
    height: auto;
    max-height: 29px;
}
`;

const SocialsBox = () => {
    const { t } = useTranslation();
    const { settings: { social_links } } = useSelector(state => state.app);

    const Link = ({ url, children }) => (
        <a href={url} target="_blank" rel="noreferrer noopen">
            {children}
        </a>
    );

    return (
        <Container>
            <Socials>
                <SocialText>
                    {t("home.appDownloadSubTitle1")}:
                </SocialText>
                <SocialBox>
                    <Link url={social_links?.fb_link}>
                        <FacebookFilled />
                    </Link>
                    <Link url={social_links?.viber_link}>
                        <ViberFilled />
                    </Link>
                    <Link url={social_links?.telegram_link}>
                        <TelegramFilled />
                    </Link>
                    <Link url={social_links?.youtube_link}>
                        <YoutubeFilled />
                    </Link>
                </SocialBox>
            </Socials>
            <Contacts>
                <ContactText>
                    {t("message.contactTitle")}
                </ContactText>
                <Space>
                    <a href={`tel:${social_links?.phones[0]}`}>
                        <BoldText>{social_links?.phones[0]}</BoldText>
                    </a>
                    <a href={`tel:${social_links?.phones[1]}`}>
                        <BoldText>{social_links?.phones[1]}</BoldText>
                    </a>
                </Space>
            </Contacts>
        </Container>
    );
}

export default SocialsBox;